import React, { ReactNode, useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Brand from '../../../layout/Brand/Brand';
import Navigation, { NavigationLine } from '../../../layout/Navigation/Navigation';
import User from '../../../layout/User/User';
import {
	dashboardPagesMenu,
	demoPagesMenu,
} from '../../../menu';
import ThemeContext from '../../../contexts/themeContext';
import useDarkMode from '../../../hooks/useDarkMode';
import Aside, { AsideBody, AsideFoot, AsideHead } from '../../../layout/Aside/Aside';
import { useFilteredMenu } from '../../../hooks/useFilteredMenu';

const DefaultAside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { t } = useTranslation(['translation', 'menu']);
	const { darkModeStatus } = useDarkMode();

	// Filter menus based on user permissions
	const filteredDashboardMenu = useFilteredMenu(dashboardPagesMenu);
	const filteredDemoMenu = useFilteredMenu(demoPagesMenu);

	return (
		<Aside>
			<AsideHead>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</AsideHead>
			<AsideBody>
				<Navigation menu={filteredDashboardMenu} id='aside-dashboard' />
				<NavigationLine />
				<Navigation menu={filteredDemoMenu} id='aside-auth-pages' />
			</AsideBody>
			<AsideFoot>
				<User />
			</AsideFoot>
		</Aside>
	);
};

export default DefaultAside;
